import { axiosObject, baseURL } from './http.helper';
import { absolutizeOrganizationAssetUrl } from './organization.helpers';

function apiOrigin(): string {
  return (baseURL ?? '').replace(/\/$/, '');
}

/** True when the logo URL points at our API (needs Authorization header). */
export function organizationLogoNeedsAuth(url: string): boolean {
  const origin = apiOrigin();
  if (!origin) return false;
  const absolute = absolutizeOrganizationAssetUrl(url.trim());
  return absolute.startsWith(origin);
}

/** Load org logo for display — uses authenticated fetch for API-hosted assets. */
export async function loadOrganizationLogoSrc(logoUrl: string): Promise<string | null> {
  const trimmed = logoUrl.trim();
  if (!trimmed) return null;

  const absolute = absolutizeOrganizationAssetUrl(trimmed);

  if (!organizationLogoNeedsAuth(trimmed)) {
    return absolute;
  }

  try {
    const response = await axiosObject.get(absolute, { responseType: 'blob' });
    return URL.createObjectURL(response.data);
  } catch {
    return null;
  }
}

/** Revoke blob URLs created by loadOrganizationLogoSrc. */
export function revokeOrganizationLogoSrc(src: string | null | undefined): void {
  if (src?.startsWith('blob:')) {
    URL.revokeObjectURL(src);
  }
}
